export const MODULE_NAME = 'marketing_estoque'
export const PERM_LOADING = null

export const PAGE_SIZE = 15

export const BR_UFS = [
  'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS',
  'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC',
  'SP', 'SE', 'TO',
] as const

export type EstoqueFornecedorFormValues = {
  name: string
  address: string
  city: string
  state: string
  contact_name: string
  phone: string
  email: string
  notes: string
  is_active: boolean
}

export const emptyFornecedorForm = (): EstoqueFornecedorFormValues => ({
  name: '',
  address: '',
  city: '',
  state: '',
  contact_name: '',
  phone: '',
  email: '',
  notes: '',
  is_active: true,
})

/** Retorna mensagem de erro ou null se válido. */
export function validateFornecedorForm(form: EstoqueFornecedorFormValues): string | null {
  if (!form.name.trim()) return 'Nome é obrigatório.'
  if (form.state && !(BR_UFS as readonly string[]).includes(form.state)) {
    return 'Selecione uma UF válida.'
  }
  return null
}

export const SELECT_CLASS =
  'rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 shadow-sm focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500 dark:border-gray-600 dark:bg-gray-900 dark:text-white'

export const TEXTAREA_CLASS =
  'w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 shadow-sm focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500 dark:border-gray-600 dark:bg-gray-900 dark:text-white'

export const PAGINATION_BTN_CLASS =
  'rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700'

export const ICON_BTN_CLASS =
  'rounded p-1.5 text-gray-500 hover:bg-gray-100 hover:text-primary-600 dark:hover:bg-gray-700'

export const ICON_BTN_DANGER_CLASS =
  'rounded p-1.5 text-gray-500 hover:bg-red-50 hover:text-red-600 dark:hover:bg-red-900/20'

export function formatQuantity(value: number | null | undefined): string {
  const n = Number(value ?? 0)
  return new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 3,
  }).format(n)
}

export function itemTypeLabel(type: string): string {
  return type === 'brinde' ? 'Brinde' : 'Material'
}

export function movementTypeLabel(type: string, quantityBefore?: number, quantityAfter?: number): string {
  if (type === 'in') return 'Entrada'
  if (type === 'out') return 'Saída'
  if (type === 'transfer') {
    if (quantityBefore != null && quantityAfter != null) {
      return quantityAfter < quantityBefore ? 'Transferência (saída)' : 'Transferência (entrada)'
    }
    return 'Transferência'
  }
  return 'Ajuste'
}

export function movementTypeBadgeClass(type: string): string {
  if (type === 'in') {
    return 'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-200'
  }
  if (type === 'out') {
    return 'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-200'
  }
  if (type === 'transfer') {
    return 'bg-sky-100 text-sky-800 dark:bg-sky-900/40 dark:text-sky-200'
  }
  return 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300'
}

export function statusBadgeClass(active: boolean): string {
  return active
    ? 'bg-teal-100 text-teal-800 dark:bg-teal-900/40 dark:text-teal-200'
    : 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300'
}

export function tabButtonClass(active: boolean): string {
  return `py-3 px-1 border-b-2 font-medium text-sm ${
    active
      ? 'border-primary-600 text-primary-600 dark:text-primary-400'
      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-200'
  }`
}

export function sortRows<T>(
  rows: T[],
  sortKey: string,
  sortOrder: 'asc' | 'desc',
  getter: (row: T, key: string) => string | number | boolean | null | undefined
): T[] {
  const sorted = [...rows]
  sorted.sort((a, b) => {
    const av = getter(a, sortKey)
    const bv = getter(b, sortKey)
    if (av == null && bv == null) return 0
    if (av == null) return 1
    if (bv == null) return -1
    if (typeof av === 'number' && typeof bv === 'number') {
      return sortOrder === 'asc' ? av - bv : bv - av
    }
    const as = String(av).toLowerCase()
    const bs = String(bv).toLowerCase()
    if (as < bs) return sortOrder === 'asc' ? -1 : 1
    if (as > bs) return sortOrder === 'asc' ? 1 : -1
    return 0
  })
  return sorted
}

export function paginateRows<T>(rows: T[], page: number, pageSize = PAGE_SIZE): T[] {
  const start = (page - 1) * pageSize
  return rows.slice(start, start + pageSize)
}
